import React from "react";

const PopularList = ({ articles }) => {
  return (
    <ol id="#topCommented" type="1" className="top-articles">
      <h1>Top 5 Most Commented Posts</h1>
      {articles.map((data, idx) => {
        const { title, name, commentSize } = data._id;

        return (
          <li key={idx}>
            <a href={`/article/${name}`}>
              <h2>{title}</h2>
            </a>
            <span>Comment section reach {commentSize} 📣 comments!</span>
          </li>
        );
      })}
    </ol>
  );
};

export default PopularList;
